import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import './Dashboard.scss';
import toast, { Toaster } from 'react-hot-toast';
import SolidGaugeChart from './SolidGaugeChart'
import { createAuthAxios } from 'utils/authAxios';





export default function Dashboard() {

  const [totalUsers, setTotalUsers] = useState(0);
  const [totalUnits, setTotalUnits] = useState(0);
  const [totalLicenses, setTotalLicenses] = useState(0);
  const [totalSessions, setTotalSessions] = useState(0);
  const emptyRecent = {month: -1, week: -1, day: -1};
  const [vicandoUsage, setVicandoUsage] = useState(emptyRecent);
  const [newUsers, setNewUsers] = useState(emptyRecent);
  const [newTrials, setNewTrials] = useState(emptyRecent);


  const API = createAuthAxios();

  async function getDashboardData() {
    try {
      const resUsers = await API.post("/admin/users/total");
      setTotalUsers(resUsers.data);
      const resUnits = await API.post("/admin/units/total");
      setTotalUnits(resUnits.data);
      const resLicenses = await API.post("/admin/licenses/total");
      setTotalLicenses(resLicenses.data);
      const resSessions = await API.post("/admin/analytics/sessions");
      setTotalSessions(resSessions.data);
      const resVicandoUsage = await API.post("/admin/analytics/vicando-usage");
      setVicandoUsage(resVicandoUsage.data)
      const resNewUsers = await API.post("/admin/analytics/new-users");
      setNewUsers(resNewUsers.data)
      const resNewTrials = await API.post("/admin/analytics/new-trials");
      setNewTrials(resNewTrials.data)
    } catch (error) {
      console.log(error?.response?.data);
      toast.error(error?.response?.data)
    }
   }


  useEffect(() => {
    getDashboardData();
  }, []);

  useEffect(() => {
      
  }, [vicandoUsage]);


    return (
<div>

  <div>
      <Toaster
          position="top-right"
          reverseOrder={false}
      />
  </div>

  <div className="header pb-6">
    <div className="container-fluid">
      <div className="header-body">
        <div className="row align-items-center py-4">
          <div className="col-lg-6 col-7">
            <h2 className="h2 d-inline-block mb-0">Dashboard</h2>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div className="container-fluid mt--6" style={{minHeight: '100vh'}}>

    <div className="row">
      <div className="col-sm-6 col-lg-3">
        <div className="card text-white bg-gradient-zeus border-0 widget-zeus" data-widget-id="totalUsersWidget">
          <div className="card-body">
            <div className="card-left pt-1 float-left">
              <h3 className="mb-0 fw-r">
                <span className="count text-white" data-widget-counter="0">{totalUsers}</span>
              </h3>
              <p className=" mt-1 m-0 text-white" data-widget-title="...">Total users</p>
            </div>
            <div className="card-right float-right text-right">
              <div className="icon icon-shape bg-gradient-green text-white rounded-circle shadow">
                <i className="ni ni-single-02"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-sm-6 col-lg-3">
        <div className="card text-white bg-gradient-zeus border-0 widget-zeus" data-widget-id="totalUnitsWidget">
          <div className="card-body">
            <div className="card-left pt-1 float-left">
              <h3 className="mb-0 fw-r">
                <span className="count text-white" data-widget-counter="0">{totalUnits}</span>
              </h3>
              <p className=" mt-1 m-0 text-white widget-title" data-widget-title="...">Total units</p>
            </div>

            <div className="card-right float-right text-right">
              <div className="icon icon-shape bg-gradient-green text-white rounded-circle shadow">
                <i className="ni ni-delivery-fast"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-lg-3">
        <div className="card text-white bg-gradient-zeus border-0 widget-zeus" data-widget-id="totalLicenses">
          <div className="card-body">
            <div className="card-left pt-1 float-left">
              <h3 className="mb-0 fw-r">
                <span className="count text-white" data-widget-counter="0">{totalLicenses}</span>
              </h3>
              <p className=" mt-1 m-0 text-white" data-widget-title="...">Total Licenses</p>
            </div>

            <div className="card-right float-right text-right">
              <div className="icon icon-shape bg-gradient-green text-white rounded-circle shadow">
                <i className="ni ni-key-25"></i>
              </div>
            </div>

          </div>

        </div>
      </div>

      <div className="col-sm-6 col-lg-3">
        <div className="card text-white bg-gradient-zeus border-0 widget-zeus" data-widget-id="totalSessions">
          <div className="card-body">
            <div className="card-left pt-1 float-left">
              <h3 className="mb-0 fw-r">
                <span className="count text-white" data-widget-counter="0">{totalSessions}</span>
              </h3>
              <p className=" mt-1 m-0 text-white" data-widget-title="...">Total Sessions</p>
            </div>

            <div className="card-right float-right text-right">
              <div className="icon icon-shape bg-gradient-green text-white rounded-circle shadow">
                <i className="ni ni-sound-wave"></i>
              </div>
            </div>

          </div>

        </div>
      </div>

    </div>

    <div className="row">
      <div className="col-xl-4">
        <div className="card widget-charts">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="mb-0" data-locale="ViCANdo Usage">ViCANdo Usage</h3>
              </div>
            </div>
          </div>
          <div className="" id="vicandousers">
            <div style={{width: '100%', height: '100%'}}>
              <SolidGaugeChart
                value={vicandoUsage}
                id="root1"
                div="chartdiv1"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-4">
        <div className="card widget-charts">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="mb-0" data-locale="New Users">New Users</h3>
              </div>
              <div className="col text-right">
                <Link to="/users" >
                  <div className="btn btn-sm btn-success" data-locale="All users">
                    All users
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="" id="newusers">
            <div style={{width: '100%', height: '100%'}}>
              <SolidGaugeChart
                value={newUsers}
                id="root2"
                div="chartdiv2"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-4">
        <div className="card widget-charts">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="mb-0" data-locale="Trial Requests">Trial Requests</h3>
              </div>
            </div>
          </div>
          <div className="" id="trialreq">
            <div style={{width: '100%', height: '100%'}}>
              <SolidGaugeChart
                value={newTrials}
                id="root3"
                div="chartdiv3"
              /> 
            </div>
          </div>
        </div>
      </div>

    </div>

        {/*
        <header>
          <h1>Welcome</h1>
          <Link to="/protected" className='Link'>Go to the page with restricted information</Link><br/>
          <Link to="/restricted" className='Link'>Go to the restricted page</Link><br/>
          <Link to="/signin" className='Link'>Go to the login page</Link><br/>
          <Link to="/logout" className='Link'>Log out</Link><br/>
          <p>{!data ? "Loading..." : data}</p>
        </header>
        */}
  </div>
</div>
    );
}